import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9 12a1 1 0 0 1 1-1h6.586l-2.293-2.293a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L16.586 13H10a1 1 0 0 1-1-1",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2 1 1 0 1 1-2 0H7v16h8a1 1 0 1 1 2 0 2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z",
      clipRule: "evenodd"
    }
  )
);
var SvgLogoutOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LogoutOutlined_default = SvgLogoutOutlined;

export { LogoutOutlined_default as default };
